// extracted by mini-css-extract-plugin
module.exports = {"hidden":"CartIndicator__hidden--1JYA5","wrapper":"CartIndicator__wrapper--1qHJR","balance":"CartIndicator__balance--3PEpy"};